var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1630250907834,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 22328,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: rbicon; src: url(\"chrome-extension://dipiagiiohfljcicegpgffpbnjmgjcnf/fonts/rbicon.woff2\") format(\"woff2\"); font-weight: normal; font-style: normal; }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M511.2 959.6c-231 0-418.9-187.9-418.9-418.9 0-154.8 84.8-296.4 221.4-369.5 21.8-11.7 48.9-3.5 60.5 18.3 11.7 21.8 3.5 48.9-18.3 60.5-107.5 57.5-174.2 168.9-174.2 290.7 0 181.6 147.8 329.4 329.4 329.4s329.4-147.8 329.4-329.4c0-122.6-67.4-234.3-176-291.6-21.8-11.5-30.2-38.6-18.7-60.4 11.5-21.8 38.6-30.2 60.4-18.7C844.3 242.8 930 384.8 930 540.7c0 231-187.9 418.9-418.8 418.9z",
    fill: "#2D3038",
    "p-id": 22329
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M511.2 564.4c-24.7 0-44.7-20-44.7-44.7V109.9c0-24.7 20-44.7 44.7-44.7 24.7 0 44.7 20 44.7 44.7v409.8c0 24.7-20 44.7-44.7 44.7z",
    fill: "#2D3038",
    "p-id": 22330
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOut);
export default __webpack_public_path__ + "static/media/out.f79655857442bd385e38f242bb2ebe6d.svg";
export { ForwardRef as ReactComponent };